import { mount } from "svelte";
import "./styles/style.scss";
import App from "./App.svelte";

export function mountApp(selector = "#btw_sitzverteilung_demografie", props = {}) {
  const targetElement = document.querySelector(selector);

  if (!targetElement) {
    throw new Error(`No element found matching the selector "${selector}"`);
  }

  return mount(App, {
    target: targetElement,
    props,
  });
}

if (import.meta.env.MODE === "development") {
  mountApp("#btw_sitzverteilung_demografie");
}
